import { StyleSheet } from 'react-native';

import { Theme } from '@constants';
import { helpers } from '@helpers';

export const styles = StyleSheet.create({
  settingsDebugMenuItem: {
    marginBottom: Theme.px(0),
  },
  settingsMenuItem: {
    height: Theme.px(40),
    marginBottom: Theme.px(helpers.DEBUG ? 42 : 62),
  },
});
